import React, { useEffect, useRef } from "react";
import {
  auditTime,
  distinctUntilChanged,
  map,
  filter,
  switchMap,
  tap,
  takeUntil,
  animationFrameScheduler,
} from "rxjs";
import PropTypes from "prop-types";
import xstream from "state-x-stream";

function controller({ props$, destroyed$ }) {
  let els = null;

  function calcText(x) {
    const { zoomService: zs } = props$.value;
    const pos = zs.xVisScale$.value.scale.invert(x);
    const { chrs } = zs.genome;
    for (let i = 0; i < chrs.length; i++) {
      const c = chrs[i];
      if (c.region.g0 < pos && c.region.g1 >= pos) {
        const diff = Math.floor(pos - c.region.g0);
        if (diff === 0) return `⦿`;
        const posStr = diff.toLocaleString();
        return `${c.name}: ${posStr}`;
      }
    }
    return null;
  }

  function updatePosition(pos) {
    const px = pos || -500;
    const positionEl = els?.positionRef?.current;
    if (positionEl) {
      positionEl.style.transform = `translateX(${px}px) translateX(-50%)`;
    }
  }

  function updateLabel(x) {
    const label = calcText(x || "");

    const labelEl = els?.labelRef.current;
    if (labelEl) {
      labelEl.innerHTML = label;
    }
  }

  props$
    .pipe(
      map((x) => x.zoomService),
      filter(Boolean),
      switchMap((x) => x.mousePosX$),
      auditTime(0, animationFrameScheduler),
      map((x) => Math.floor(x || 0)),
      distinctUntilChanged(),
      tap(updatePosition),
      auditTime(500),
      tap(updateLabel),
      takeUntil(destroyed$)
    )
    .subscribe();

  return {
    updateElements: (x) => {
      els = x;
    },
  };
}

function Position({ updateElements }) {
  const containerRef = useRef(null);
  const positionRef = useRef(null);
  const labelRef = useRef(null);

  useEffect(() => {
    updateElements({ containerRef, positionRef, labelRef });
  });

  return (
    <div ref={containerRef}>
      <div
        ref={positionRef}
        className="tw-absolute tw-bottom-0 tw-w-128 tw-top-10 tw-pointer-events-none"
      >
        <div className="tw-flex tw-flex-col tw-h-full tw-items-center tw-text-2xs">
          <div className="tw-text-xs tw-px-2 tw-py-0.5 bg-1">
            <span className="tw-font-bold tw-text-sky-500" ref={labelRef} />
          </div>
          <div className="tw-flex-grow tw-w-px tw-opacity-40 tw-bg-blueGray-400 tw-h-full" />
        </div>
      </div>
    </div>
  );
}

Position.propTypes = {
  updateElements: PropTypes.func.isRequired,
};

export default xstream(controller)(Position);
